import React,{ useState, useEffect } from 'react';
import { 
    Alert,
    Card,
    Button
} from 'antd';

import {
    GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3';

import { 
    RightOutlined,
    PhoneOutlined,
    MessageOutlined
} from '@ant-design/icons';

import TransferForm from './TransferForm';

const siteDomain = headerVars.siteDomain;

function NumberTransferForm() {
    const [ recaptchaContainer, setRecaptchaContainer ] = useState( <></> );

    const captchaKey = "6LdmP8QkAAAAACX1XkPWEZ08HGoIkk1nClZiagMJ";

    useEffect(() => {
        setTimeout(function(){
            setRecaptchaContainer(
                <GoogleReCaptchaProvider
                    reCaptchaKey={ captchaKey }>
                    <TransferForm />
                </GoogleReCaptchaProvider> 
            );
        }, 1000)
    }, []);

    return (
        <div className="react-contact-form">
            <h1>Your number stays with you</h1>
            <p>Keep your existing phone number with our free transfer offer.</p>
            <p style={{ fontSize: '0.9rem' }}>*Valid for Ontario numbers only.</p>
            <Alert
                message={<span style={{ fontSize: '1.5rem', fontWeight: 700 }}
                >Important information</span>}
                style={{ marginTop: '2rem' }}
                description={ 
                    <div>
                        <p>When transferring a number it is important to note that you must not cancel your current phone provider before the transfer is 100% complete. If you cancel your service before the port is completed the transfer will fail and your number may be lost. Other errors such as an incorrect name or address will cause the transfer to fail so please double-check all information is correct.</p>
                        <div style={{ fontSize: '1.2rem', fontWeight: 600 }}>
                            Next steps
                        </div>
                        <ol style={{ marginLeft: '0', paddingLeft: '1rem' }}>
                            <li style={{ marginLeft: '0' }}>Complete all of the information in the form below.</li>
                            <li style={{ marginLeft: '0' }}>Confirm the details and submit the transfer request for processing.</li>
                            <li style={{ marginLeft: '0' }}>DO NOT CANCEL YOUR CURRENT PHONE PROVIDER BEFORE THE TRANSFER IS 100% COMPLETE.</li>
                            <li style={{ marginLeft: '0' }}>When you submit your phone port form, please make sure the Name and Address match the information on your phone bill, otherwise there can be delays.</li>
                        </ol>

                    </div> }
                type="warning"
                showIcon
            />
            <div className='contact-form-content-container'>
                { recaptchaContainer }
            </div>
        </div>
    )
}

export default NumberTransferForm
